export default {
	/**
	 * init post Teaser screenreader labels
	 */
	init() {
		[...this.$el.getElementsByClassName('post--teaser')].forEach(post => {
			[...post.getElementsByClassName('post__wrapper')].forEach(wrapper =>
				wrapper.setAttribute('aria-hidden', true)
			);
			const headline = post.querySelector('.post__wrapper--text > .element--headline');
			const text = post.querySelector('.post__wrapper--text > .element--text');

			post.setAttribute(
				'aria-label',
				`${headline ? headline.textContent : ''}\n${text ? text.textContent : ''}`
			);
			post.setAttribute('role', 'link');
			post.setAttribute('tabindex', 0);
		});
	},
	destroy() {},
};
